/* import external modules */
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  flex: {
    width: '400px',
    display: 'flex',
    gap: '24px',
    margin: 'auto',
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
      display: 'block',
      textAlign: 'center',
    },
  },
  barcode: {
    // background:'blue',
    width: 'auto',
    maxHeight: '200px',
    maxWidth: '400px',
    textAlign: 'center',
    margin: '20px auto 0',
    '& > canvas': {
      width: '100%',
      height: '85%',
    },
    '& > svg': {
      width: '100%',
      height: '85%',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: '300px',
    },
  },
  actions: {
    width: '50px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: '24px',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      margin: '24px auto 0',
    },
  },
  button: {
    background: '#FFF6F6',
  },
  title_nid: {
    fontWeight: 900,
    fontSize: 28,
    color: 'black',
  },
}));

export default useStyles;
